import { render } from "./ConsentCard.vue?vue&type=template&id=7318a48c&scoped=true"
import script from "./ConsentCard.vue?vue&type=script&lang=js"
export * from "./ConsentCard.vue?vue&type=script&lang=js"

import "./ConsentCard.vue?vue&type=style&index=0&id=7318a48c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7318a48c"]])

export default __exports__